export default {
      id: "shipment__food-usage",
      viewBox: "0 0 24 16",
      url: __webpack_public_path__ + "img/icons.svg#shipment__food",
      toString: function () {
        return this.url;
      }
    }